import {
  ContactsOutlined,
  HomeOutlined,
  MedicineBoxOutlined,
  PhoneOutlined,
  RetweetOutlined,
  TeamOutlined,
  DisconnectOutlined
} from '@ant-design/icons';
import { DatePicker } from 'antd';

import TextArea from 'antd/lib/input/TextArea';
import { disabledFutureDates, getMonthName } from 'commons/helpers/utils';

export const getEventIcon = (index) => {
  const style = { fontSize: 29, color: 'var(--color-brand-navy)' };
  switch (index) {
    case 1:
      return <MedicineBoxOutlined style={style} />;
    case 2:
      return <HomeOutlined style={style} />;
    case 3:
      return <RetweetOutlined style={style} />;
    case 4:
      return <ContactsOutlined style={style} />;
    case 5:
      return <TeamOutlined style={style} />;
    case 6:
      return <DisconnectOutlined style={style} />;
    case 7:
      return <PhoneOutlined style={style} />;
    default:
      return <span></span>;
  }
};

export const getFormItems = (translate) => {
  return [
    {
      item: (
        <DatePicker disabledDate={disabledFutureDates} format={'DD/MM/YYYY'} />
      ),
      name: ['registerDate'],
      label: translate('patientEvents.date'),
      rules: [{ required: true }]
    },
    {
      item: <TextArea rows={4} maxLength={400} />,
      name: ['description'],
      label: translate('patientEvents.comments')
    }
  ];
};

export const formatModalDate = (date, translate) => {
  const formatedDate = new Date(date);
  const day = formatedDate.getDate();
  const month = translate(getMonthName(formatedDate.getMonth()));
  const year = formatedDate.getFullYear();
  return `${day}, ${month}, ${year}`;
};
